import { DatabaseContentType } from '../modules/database/models/database.model';
export enum ContentType {
  blocks = 'blocks',
  slides = 'slides',
  works = 'oeuvre',
  work = 'oeuvre',
  artist = 'artist',
  collector = 'collec',
}

export enum CollectionType {
  work,
  artist,
  collector,
  seller,
  other,
  address,
  exhibit,
}

export const DATABASE_TO_COLLECTION_TYPE = {
  [DatabaseContentType.WORKS]: CollectionType.work,
  [DatabaseContentType.ARTISTS]: CollectionType.artist,
  [DatabaseContentType.ADDRESSES]: CollectionType.address,
  [DatabaseContentType.COLLECTORS]: CollectionType.collector,
  [DatabaseContentType.OTHERS]: CollectionType.other,
  [DatabaseContentType.SELLERS]: CollectionType.seller,
  [DatabaseContentType.EXHIBIT]: CollectionType.exhibit,
};

export const COLLECTION_TO_CONTENT_TYPE = {
  [CollectionType.work]: ContentType.work,
};

export enum ViewType {
  wall,
  table,
  slider,
}

export enum UploadFieldName {
  pic = 'pic',
  attach = 'attach',
}

export enum AccessType {
  private,
  public,
}

export enum Sharing {
  private = 'private',
  public = 'exhibited',
}

export enum FilterType {
  type = 'nature',
  artist = 'artist',
  seller = 'interm',
  nationality = 'nationalite',
}

export enum TableFields {
  // works
  imageUrl = 'nom_pic',
  ID = 'ID',
  ID2 = 'ID2',
  artist = 'nom_art',
  title = 'titre',
  year = 'annee_crea',
  type = 'nature',
  dimension = 'dim1',
  sharing = 'partage',

  // artist
  nationality = 'nationalite',

  // collector
  collector = 'nom_col',

  // seller
  status = 'statut',
  intermediary = 'nom_int',

  // others
  otherStorages = 'nom_aut',
  organization = 'nom_org',
  email = 'adr_mail',
  website = 'site_web',
  address = 'label_adr',

  // address
  addressType = 'type_parent',
  owner = 'label_par',
  street = 'adr1',
  city = 'ville',
  postalCode = 'cp',
  country = 'pays',
}

export enum ApiRelatedFields {
  sharing = 'partage',
  depot = 'adress',
  location = 'location',
  receipt = 'facture',
  certificate = 'certif',
  currencies = 'devise',
  type = 'nature',
  seller = 'interm',
  collector = 'collec',
  artist = 'artist',
}

export enum AddressType {
  client = 'Client',
  artist = 'Artist',
  autres = 'Other',
  collec = 'Collector',
  interm = 'Intermediary',
  selected = 'interm',
}

export enum AddressTypeDB {
  intermediary = 'interm', // seller
  other = 'autres', // others,
  artist = 'artist', // artist,
  collector = 'collec', // collector,
}

export enum SharingType {
  public = '1',
  private = '2',
}

export enum ApiBooleanResponse {
  true = '1',
  false = '2',
}
